<div [ngClass]="colorClass$()">
	<div
		class="header"
		(click)="showMessages = !showMessages"
		(keyup.enter)="showMessages = !showMessages"
		[tabindex]="0"
		[class.expandable]="hasMessages$()"
	>
		@if (hasMessages$()) {
			<g-icon [icon]="icons[showMessages ? 'faSquareMinus' : 'faSquarePlus']" />
		}
		<div fxFlex class="header-message">
			@if (!hasPrintfile$()) {
				<span i18n="@@PrintfileReportPrintfileMissing">Printfile missing</span>
			}
			@if (isPrintable$() && warnings$().length > 0) {
				<span i18n="@@PrintfileReportPrintfileHasWarnings"
					>Printfile contains a warning that does not prevent printing</span
				>
			}
			@if (!isPrintable$() && errors$().length > 0) {
				<span i18n="@@PrintfileReportPrintfileHasErrors"
					>Printfile contains an error that prevents printing</span
				>
			}
		</div>
		@if (!readOnly$()) {
			<g-printfile-status-buttons [cartItem]="item$()" [allowRetry]="false" />
		}
	</div>
	@if (showMessages && hasMessages$()) {
		<div class="body">
			@if (warnings$()?.length) {
				<g-printfile-report-message [report]="warnings$()" />
			}
			@if (warnings$()?.length && errors$()?.length) {
				<hr />
			}
			@if (errors$()?.length) {
				<g-printfile-report-message [report]="errors$()" />
			}

			@if (!readOnly$() && isFixable$()) {
				<form class="fix-it-form">
					<label class="request">
						<input
							type="checkbox"
							name="requestPremediaFix"
							[ngModel]="isFixRequested$()"
							(ngModelChange)="toggleFixRequest($event)"
						/>
						<span i18n="@@PrintfileReportPremediaFixRequestLabel"
							>I want Grano to fix my material for an extra fee</span
						>
						<span> (+{{ getPreMediaPrice$ | async }})</span>
					</label>
					@if (isFixRequested$()) {
						<label class="note">
							<span i18n="@@PrintfileReportPremediaFixMessageLabel">Leave a note</span>
							<textarea
								name="premediaFixDescription"
								rows="3"
								[(ngModel)]="fixMessage"
								(blur)="updateFixRequestMessage()"
								maxlength="250"
								#message="ngModel"
								i18n-placeholder="@@PrintfileReportPremediaFixMessagePlaceholder"
								placeholder="Fill missing pages with cat pictures..."
							>
							</textarea>
							<div class="characters-left">
								<span>{{ 250 - message?.value?.length }}</span>
							</div>
						</label>
					}
				</form>
			}
		</div>
	}
</div>
